import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { apiGet } from '@/api/api.ts'

// 위치 정보 인터페이스
export interface IUserPosition {
  order: number
  latitude: number
  longitude: number
  accuracy: number
  timestamp: string
}

// 날짜별 데이터 존재 여부 인터페이스
export interface IDateAvailability {
  date: string;
  hasData: boolean;
  isLoading: boolean;
}

// 회원의 특정 날짜 또는 오늘 위치 정보 조회 API
export const apiGetUserDailyPosition = async (userId: number, date?: string) => {
  // 엔드포인트 URL
  let url = `/protectee/${userId}/daily-position`;
  if (date) {
    url += `?date=${date}`;
  }

  return await apiGet<IUserPosition[]>(url);
}

// 특정 날짜의 데이터 존재 여부 확인
export const checkDateHasData = async (userId: number, date: string): Promise<boolean> => {
  try {
    const response = await apiGetUserDailyPosition(userId, date);
    return Array.isArray(response.data) && response.data.length > 0;
  } catch (error) {
    return false;
  }
}

// 위치 정보 쿼리 훅
const useQueryGetUserDailyPosition = (userId: number, date?: string) => {
  return useQuery({
    enabled: userId > 0,
    queryKey: QueryCacheKeys.user.getUserDailyPosition(userId, date),
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 30000, // 30초간 캐시 유지
    queryFn: async () => {
      try {
        const response = await apiGetUserDailyPosition(userId, date);
        return Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        return [];
      }
    }
  })
}

export default useQueryGetUserDailyPosition 